<template>
  <div class="page">
    <div class="floor floor_1">
      <div class="title">连接网络前请检查以下事项</div>
      <div class="content">
        <div class="text">
          选择2.4G
          WI-FI并输入密码后点击连接（暂不支持5G网络，如果是2.4G跟5G复合网络，需要在路由器设置网址192.168.1.1上取消5G优先，调出2.4Gwifi）
        </div>
        <img src="@/assets/document/setNet/image_1.png" />
      </div>
    </div>

    <div class="floor floor_2">
      <div class="title">设备联网</div>
      <div class="content">
        <li class="text">
          首次使用设备通电后白色状态指示灯在快闪状态（1秒闪烁两次）；
        </li>
        <img src="@/assets/document/setNet/image_2.gif" />
        <li class="text">
          等待3秒左右使用“特屋兔APP”对设备进行配网，手机需和设备在同一WIFI网络的覆盖下；
        </li>
      </div>
    </div>

    <div class="floor floor_3">
      <div class="title">重置设备</div>
      <div class="content">
        <div class="text">
          如果通电后，网络指示灯白灯在快闪状态（1秒两次），请跳过此步骤：
        </div>
        <br />
        <li class="text">给设备接通电源；</li>
        <br />
        <li class="text">使用卡针插入设备小孔中保持3秒以上</li>
        <img src="@/assets/document/setNet/image_3.gif" />
        <li class="text">
          指示灯一秒闪烁2次即可点击下一步，若没闪烁，请重复操作上一步
        </li>
      </div>
    </div>

    <div class="floor floor_4">
      <div class="title">连接失败说明</div>
      <div class="content">
        <div class="text">
          1、确保输入的路由器密码正确<br />
          2、保持设备、手机、路由器三者靠近<br />
          3、确保使用2.4G的Wi-Fi频段添加设备，Wi-Fi需要开启广播，不可设置为隐藏<br />
          4、若路由器开启无线MAC地址过滤，可以尝试将设备移出路由器过滤列表，保证路由器没有禁止设备联网。
        </div>
      </div>
    </div>

    <div class="floor floor_5">
      <div class="title">2.4G网络设置说明</div>
      <div class="content">
        <div class="text">
          如果您的路由器同时支持2.4Ghz和5Ghz两个的Wi-Fi，但是在手机的Wi-Fi搜索页面中却只能搜到一个Wi-Fi名称，请参考以下操作步骤:<br />
          1、进入路由器的“无线设置(Wireless)”页面(进入方法通常在路由器背面的标签上)。<br />
          2、找到2.4Ghz的设置页面，将Wi-Fi名称(SSID)更改为“xxx-2.4G”，保存设置。<br />
          3、找到5Ghz的设置页面，将Wi-Fi名称(SSID)更改为“xxx-5G”，保存设置。<br />
          4、更名完成后，即可在手机的Wi-Fi搜索页面中分别找到“xxx-2.4G”和“xxx-5G两个Wi-Fi名称了。<br />
          注:由于Wi-Fi名称已变更，所有连接该无线路由器的设备都需要重新连网，如果未对密码发生变更则依然为原密码。
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  components: {},

  props: {},

  data() {
    return {};
  },

  filters: {},
  computed: {},
  watch: {},

  created() {},

  methods: {},
};
</script>

<style scoped lang="scss">
.page {
  padding: 40px;

  .floor {
    margin-bottom: 80px;

    .title {
      font-size: 40px;
      font-family: SourceHanSansCN-Bold, SourceHanSansCN;
      font-weight: bold;
      color: #4d4d4d;
    }

    .content {
      margin-top: 30px;

      .text {
        font-size: 36px;
        font-family: SourceHanSansCN-Normal, SourceHanSansCN;
        font-weight: 400;
        color: #333333;
      }

      li {
        list-style-type: disc;
      }

      img {
        display: block;
        margin: 60px auto;
      }
    }
  }

  .floor_1 {
    .content {
      img {
        width: 480px;
      }
    }
  }
  .floor_2 {
    .content {
      img {
        width: 350px;
      }
    }
  }
  .floor_3 {
    .content {
      img {
        width: 468px;
      }
    }
  }
}
</style>
